<script lang="ts" setup>
defineProps<{
  color: string,
  aria: string,
  active?: boolean,
  icon: string,
  iLarge?: boolean,
  bSmall?:boolean,
  disabled?: boolean,
}>()
defineEmits<{
  (e: 'activate'): void
}>()
</script>

<template>
  <q-btn
    fab
    outline
    :aria-label="aria"
    :disabled="disabled"
    :color="color ? color : 'primary'"
    :size="bSmall ? 'xs': 'md'"
    :input-value="active"
    @click="$emit('activate')"
  >
    <q-icon :large="iLarge">
      {{ icon }}
    </q-icon>
  </q-btn>
</template>

